import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { projectStates } from "../../constants";
import { Icon, Popup, Header } from "semantic-ui-react";
import { ProjectUploadProgress, ProjectRecordedProgress } from "../helpers";

const ProjectListItem = ({ project }) => {
  const numberOfRecordings = () => {
    if (project.state !== projectStates.OK) return;
    return <p>{project.total_recordings} recordings</p>;
  };

  const stateIcon = () => {
    switch (project.state) {
      case projectStates.OK:
        return <Icon circular name="check" color="green" />;
      case projectStates.PROCESSING:
        return <Icon circular loading name="spinner" />;
      case projectStates.ERROR:
        const icon = <Icon circular name="exclamation circle" color="red" />;
        const errorsList = project.errors ? (
          <ul>
            {project.errors.map((err, i) => (
              <li key={i}>{err}</li>
            ))}
          </ul>
        ) : null;
        return (
          <Popup trigger={icon} inverted on="hover" content={errorsList} />
        );
      default:
    }
  };

  const timeInfo = () => {
    if (project.state !== projectStates.OK) return;
    return (
      <>
        <Header style={{ display: "inline" }} sub content="recorded: " />
        {msToHHMMSS(project.recorded_duration)}
        <br />
        <Header style={{ display: "inline" }} sub content="total: " />
        {msToHHMMSS(project.total_duration)}
      </>
    );
  };

  const progressBar = () => {
    switch (project.state) {
      case projectStates.UPLOADING:
        return <ProjectUploadProgress value={project.uploaded} />;
      case projectStates.OK:
        return (
          <ProjectRecordedProgress
            value={project.recorded_duration}
            total={project.total_duration}
          />
        );
      default:
    }
  };

  return (
    <div style={flexBoxStyle}>
      <div style={flexItemStyle(30)}>
        <p style={{ color: "#4183c4", margin: 0 }}>{project.name}</p>
        {project.url.split("/")[1]}
        {numberOfRecordings()}
      </div>
      <div style={flexItemStyle(5)}>{stateIcon()}</div>
      <div style={flexItemStyle(10)}>{timeInfo()}</div>
      <div style={flexItemStyle(30)}>{progressBar()}</div>
    </div>
  );
};

const msToHHMMSS = (ms) => {
  return moment.utc(moment.duration(ms).asMilliseconds()).format("HH:mm:ss");
};

const flexBoxStyle = {
  display: "flex",
  // justifyContent: "space-evenly",
  justifyContent: "flex-start",
  alignContent: "center",
  // marginRight: "7%"
};

const flexItemStyle = (size) => ({
  width: `${size}%`,
  marginRight: "5%",
});

ProjectListItem.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    slug: PropTypes.string,
    state: PropTypes.string.isRequired,
    total_recordings: PropTypes.number,
    finished_recordings: PropTypes.number,
    approved_recordings: PropTypes.number,
    total_duration: PropTypes.number,
    recorded_duration: PropTypes.number,
    errors: PropTypes.array,
  }).isRequired,
};

export default ProjectListItem;
